
import { IEmployerHistoryViewState } from './state';
import { createReducer, on, State, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';

export const viewState: IEmployerHistoryViewState = {
  list: []
};

const reducer = createReducer(viewState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      list: payload
    };
  })
);

export function employerHistoryViewReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
